module.exports = __webpack_public_path__ + "static/img/radio.1db061a7.svg";